import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";

interface UseReviewContractProps {
  privateCompanyLeadId?: string
  state?: string
  onSuccess: () => void
  onError: () => void
}

const useReviewContract = ({ privateCompanyLeadId, state, onSuccess, onError }: UseReviewContractProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['reviewContract'],
    mutationFn: async (data?: { description?: string }) => {
      const private_company_lead = {
        contract_attributes: {
          last_review_attributes: {
            state,
            description: data?.description
          }
        }
      }

      await privateAxios.putForm(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  });
}

export default useReviewContract